import type { KeyboardEvent } from 'react';

const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
  if (event.target !== event.currentTarget) return;
  if (event.ctrlKey || event.metaKey || event.altKey || event.nativeEvent.isComposing) return;
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  if (event.repeat) return;
  event.currentTarget.click();
};

type PressableRole = 'button' | 'radio' | 'checkbox' | 'tab';

const buildProps = (role: PressableRole) =>
  ({ role, tabIndex: 0, onKeyDown: handleKeyDown }) as const;

const PRESSABLE_PROPS = {
  button: buildProps('button'),
  radio: buildProps('radio'),
  checkbox: buildProps('checkbox'),
  tab: buildProps('tab'),
} as const;

export const getPressableProps = (
  isActive = true,
  role: PressableRole = 'button',
) => (isActive ? PRESSABLE_PROPS[role] : {});
